import { DISCIPLINE_TAGS, PRODUCT_TAGS, REGION_TAGS } from "@/data/presetTags";
import { canonicalizeRegion } from "@/utils/localStore";
const disciplineSet = new Set(DISCIPLINE_TAGS);
const productSet = new Set(PRODUCT_TAGS);
const regionSet = new Set(REGION_TAGS);
const REGION_MAP = {
  EU: "Europe",
  EEA: "Europe",
  "Northern Ireland": "Europe",
  US: "North America",
  "United States": "North America",
  "US Territories": "North America",
  California: "North America",
  "US (market influence)": "North America",
  APAC: "Asia"
};
function mapRegion(raw) {
  if (regionSet.has(raw)) return raw;
  if (REGION_MAP[raw]) return REGION_MAP[raw];
  return canonicalizeRegion(raw);
}

/**
 * Classify an item's tags into preset discipline/product/region categories.
 *
 * Works with any object shape — checks filterTags/miscTags/regionTags first,
 * then falls back to tags/regions for items that lack categorised fields.
 */
export function classifyItemTags(item) {
  const filterTags = item.filterTags ?? [];
  const miscTags = item.miscTags ?? [];
  const regionTags = item.regionTags ?? [];
  const tags = item.tags ?? [];
  const regions = item.regions ?? [];
  const disciplines = new Set();
  const products = new Set();
  const mappedRegions = new Set();

  // Classified fields take priority
  for (const t of filterTags) if (disciplineSet.has(t)) disciplines.add(t);
  for (const t of miscTags) if (productSet.has(t)) products.add(t);
  for (const r of regionTags) {
    const mapped = mapRegion(r);
    if (mapped) mappedRegions.add(mapped);
  }

  // Fall back to generic tags/regions when categorised fields are empty
  if (filterTags.length === 0 && miscTags.length === 0) {
    for (const t of tags) {
      if (disciplineSet.has(t)) disciplines.add(t);else if (productSet.has(t)) products.add(t);
    }
  }
  if (regionTags.length === 0) {
    for (const r of regions) {
      const mapped = mapRegion(r);
      if (mapped) mappedRegions.add(mapped);
    }
  }
  return {
    disciplines: Array.from(disciplines),
    products: Array.from(products),
    regions: Array.from(mappedRegions)
  };
}